module.exports = __webpack_public_path__ + "img/apple2.43592028.png";